import {Injectable} from '@angular/core';

import {NgbModal, NgbModalRef} from '@ng-bootstrap/ng-bootstrap';

@Injectable()
export class KngDrawerService {
  constructor(private modalService: NgbModal) {
  }

  launch(content, options): NgbModalRef {
    // angular.element('body').addClass('blur');

    let windowClass: string = 'kng-drawer-window';

    if(options.windowClass){
      windowClass = windowClass + ' ' + options.windowClass;
      // console.log('new WindowClass: ' + windowClass);
    }

    let drawerInstance = this.modalService.open(content, {
      backdrop: 'static',
      size: 'lg',
      keyboard: false,
      windowClass: windowClass
    });

    return drawerInstance;
  }
}



// WEBPACK FOOTER //
// D:/dclean-web-latest/cot-web/src/app/layout/kingswell/services/kngDrawer.service.ts